import { Union, Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { union_type, record_type, bool_type, string_type, int32_type, option_type, class_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC__toDateTime, UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";
import { PeriodModule_toTranslation, PeriodModule_ofString, Period$reflection } from "../../DomainTypes.js";
import { now, addMonths } from "../../fable_modules/fable-library.3.7.20/Date.js";
import { DateOnlyExtensions_toDate, decimalToTwoDecimals, getRemainingBoundMonths } from "../../Utils.js";
import { int32ToString } from "../../fable_modules/fable-library.3.7.20/Util.js";
import { bind, map, defaultArg } from "../../fable_modules/fable-library.3.7.20/Option.js";
import { tryFind } from "../../fable_modules/fable-library.3.7.20/List.js";
import { toString } from "../../fable_modules/fable-library.3.7.20/Decimal.js";

export class Fee extends Record {
    constructor(AmountExclVat, BilledTo, BoundMonths, BoundTo, BoundToDate, CancellationPeriodMonths, CancelledAt, CancelledBy, CancelledDate, CreatedBy, CreatedTime, Description, EndDate, FeeNumber, FeeTemplateNr, FinalInvoiceSent, MonthsInAdvance, NoNextInvoice, Period, RemainingBoundMonths, StartDate, VatRatePercent, AccountNo, Units, UnitPrice) {
        super();
        this.AmountExclVat = AmountExclVat;
        this.BilledTo = BilledTo;
        this.BoundMonths = (BoundMonths | 0);
        this.BoundTo = BoundTo;
        this.BoundToDate = BoundToDate;
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.CancelledAt = CancelledAt;
        this.CancelledBy = CancelledBy;
        this.CancelledDate = CancelledDate;
        this.CreatedBy = (CreatedBy | 0);
        this.CreatedTime = CreatedTime;
        this.Description = Description;
        this.EndDate = EndDate;
        this.FeeNumber = (FeeNumber | 0);
        this.FeeTemplateNr = FeeTemplateNr;
        this.FinalInvoiceSent = FinalInvoiceSent;
        this.MonthsInAdvance = (MonthsInAdvance | 0);
        this.NoNextInvoice = NoNextInvoice;
        this.Period = Period;
        this.RemainingBoundMonths = (RemainingBoundMonths | 0);
        this.StartDate = StartDate;
        this.VatRatePercent = VatRatePercent;
        this.AccountNo = (AccountNo | 0);
        this.Units = (Units | 0);
        this.UnitPrice = UnitPrice;
    }
}

export function Fee$reflection() {
    return record_type("Containers.FeesTable.Model.Fee", [], Fee, () => [["AmountExclVat", class_type("System.Decimal")], ["BilledTo", option_type(class_type("System.DateOnly"))], ["BoundMonths", int32_type], ["BoundTo", class_type("System.DateOnly")], ["BoundToDate", option_type(class_type("System.DateOnly"))], ["CancellationPeriodMonths", int32_type], ["CancelledAt", option_type(UTC$reflection())], ["CancelledBy", option_type(int32_type)], ["CancelledDate", option_type(class_type("System.DateOnly"))], ["CreatedBy", int32_type], ["CreatedTime", UTC$reflection()], ["Description", string_type], ["EndDate", option_type(class_type("System.DateOnly"))], ["FeeNumber", int32_type], ["FeeTemplateNr", option_type(int32_type)], ["FinalInvoiceSent", bool_type], ["MonthsInAdvance", int32_type], ["NoNextInvoice", bool_type], ["Period", Period$reflection()], ["RemainingBoundMonths", int32_type], ["StartDate", class_type("System.DateOnly")], ["VatRatePercent", class_type("System.Decimal")], ["AccountNo", int32_type], ["Units", int32_type], ["UnitPrice", class_type("System.Decimal")]]);
}

export function Fee_FromDTO(clientNr, f) {
    let matchValue;
    return new Fee(f.AmountExclVat, f.BilledTo, f.BoundMonths, (matchValue = f.BoundToDate, (matchValue == null) ? addMonths(f.StartDate, f.BoundMonths) : matchValue), f.BoundToDate, f.CancellationPeriodMonths, f.CancelledAt, f.CancelledByUserIdby, f.CancelledDate, f.CreatedByUserId, f.CreatedAt, f.Description, f.EndDate, f.FeeNr, f.FeeTemplateNr, f.FinalInvoiceSent, f.MonthsInAdvance, f.NoNextInvoice, PeriodModule_ofString(f.Type), getRemainingBoundMonths(clientNr, now(), f.StartDate, f.CreatedAt, f.BoundMonths), f.StartDate, f.VatPercentage, f.AccountNo, f.Units, f.UnitPrice);
}

export class EditFeeRowViewModel extends Record {
    constructor(Description, Amount, BoundMonths, StartDate, EndDate, Period, FeeNumber, FeeTemplateNr, FeeTemplateDescription, FinalInvoiceSent, VatRatePercent, MonthsInAdvance, CancellationPeriodMonths, BoundTo, BilledTo, CreatedBy, CreatedTime, RemainingBoundMonths, Units, UnitPrice) {
        super();
        this.Description = Description;
        this.Amount = Amount;
        this.BoundMonths = BoundMonths;
        this.StartDate = StartDate;
        this.EndDate = EndDate;
        this.Period = Period;
        this.FeeNumber = (FeeNumber | 0);
        this.FeeTemplateNr = FeeTemplateNr;
        this.FeeTemplateDescription = FeeTemplateDescription;
        this.FinalInvoiceSent = FinalInvoiceSent;
        this.VatRatePercent = VatRatePercent;
        this.MonthsInAdvance = MonthsInAdvance;
        this.CancellationPeriodMonths = (CancellationPeriodMonths | 0);
        this.BoundTo = BoundTo;
        this.BilledTo = BilledTo;
        this.CreatedBy = CreatedBy;
        this.CreatedTime = CreatedTime;
        this.RemainingBoundMonths = (RemainingBoundMonths | 0);
        this.Units = (Units | 0);
        this.UnitPrice = UnitPrice;
    }
}

export function EditFeeRowViewModel$reflection() {
    return record_type("Containers.FeesTable.Model.EditFeeRowViewModel", [], EditFeeRowViewModel, () => [["Description", string_type], ["Amount", string_type], ["BoundMonths", string_type], ["StartDate", string_type], ["EndDate", string_type], ["Period", string_type], ["FeeNumber", int32_type], ["FeeTemplateNr", string_type], ["FeeTemplateDescription", string_type], ["FinalInvoiceSent", bool_type], ["VatRatePercent", string_type], ["MonthsInAdvance", string_type], ["CancellationPeriodMonths", int32_type], ["BoundTo", class_type("System.DateOnly")], ["BilledTo", option_type(class_type("System.DateOnly"))], ["CreatedBy", string_type], ["CreatedTime", class_type("System.DateTime")], ["RemainingBoundMonths", int32_type], ["Units", int32_type], ["UnitPrice", class_type("System.Decimal")]]);
}

export function convertFeeToViewModel(getTranslation, locale, feeTemplates, fee) {
    return new EditFeeRowViewModel(fee.Description, decimalToTwoDecimals(fee.AmountExclVat), int32ToString(fee.BoundMonths), DateOnlyExtensions_toDate(locale.ILocale, fee.StartDate), defaultArg(map((date_1) => DateOnlyExtensions_toDate(locale.ILocale, date_1), fee.EndDate), ""), PeriodModule_toTranslation(getTranslation, fee.Period), fee.FeeNumber, defaultArg(map(int32ToString, fee.FeeTemplateNr), "-"), defaultArg(map((feeTemplate) => feeTemplate.Description, bind((feeTemplateNr) => tryFind((ft) => (ft.FeeTemplateNr === feeTemplateNr), feeTemplates), fee.FeeTemplateNr)), "-"), fee.FinalInvoiceSent, toString(fee.VatRatePercent), int32ToString(fee.MonthsInAdvance), fee.CancellationPeriodMonths, fee.BoundTo, fee.BilledTo, int32ToString(fee.CreatedBy), UTC__toDateTime(fee.CreatedTime), fee.RemainingBoundMonths, fee.Units, fee.UnitPrice);
}

export function isActiveFee(fee) {
    if (!fee.FinalInvoiceSent) {
        return !fee.NoNextInvoice;
    }
    else {
        return false;
    }
}

export function findFee(fees, feeNumber) {
    return tryFind((fee) => (fee.FeeNumber === feeNumber), fees);
}

export class Modal extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Nothing", "EditFee", "TerminateFee", "AnnulFee", "EditInvoicing"];
    }
}

export function Modal$reflection() {
    return union_type("Containers.FeesTable.Model.Modal", [], Modal, () => [[], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class TerminateFeeDetails extends Record {
    constructor(Date$, RemoveCancellationPeriod, RemoveBoundMonths) {
        super();
        this.Date = Date$;
        this.RemoveCancellationPeriod = RemoveCancellationPeriod;
        this.RemoveBoundMonths = RemoveBoundMonths;
    }
}

export function TerminateFeeDetails$reflection() {
    return record_type("Containers.FeesTable.Model.TerminateFeeDetails", [], TerminateFeeDetails, () => [["Date", class_type("System.DateTime")], ["RemoveCancellationPeriod", bool_type], ["RemoveBoundMonths", bool_type]]);
}

